import React from 'react'

//Node Modules
import { useTranslation} from 'react-i18next'

import {Nav, Navbar} from 'react-bootstrap'

//Styles
import styles from './Header.module.scss'

const Header = () => {
  //test
  const { t } = useTranslation()

  return (
    <Navbar className={`${styles.header} ${styles.topHeader}`} variant="dark" role="none">
      <Nav>
        <Navbar.Brand className={styles.brand}>
          {t('helpcenter-gui-icu.header.banner.title')}
        </Navbar.Brand>
      </Nav>
    </Navbar>
  )
}

export default Header